import React, { useContext, useEffect, useState } from "react";

import Button from "../../components/button";
import APIAuth from "../../services/APIAuth";
import Logo from '../../assets/logoPortalCliente.svg'

import {
  AnimationContainer,
} from "./styles"

import SelectionLabel from '../../components/selectionlabel';
import Options from "../../components/select/options";
import Checkbox from "../../components/checkbox";
import ConfirmationModal from "../../components/confirmationmodal";
import Loader from "react-loader-spinner";
import ToastContext from "../../contexts/toast";
import AuthContext from "../../contexts/auth";
import { CustumerContext } from "../../contexts/custumer";
import Utils from '../../utils/auxiliar'
import APIUser from "../../services/APIUser";
import storage from "../../storage";
import PasswordChangeModal from "./../../components/passwordchangemodal";
import { CompanySelectOptions, Group } from "../../@types";
import { useHistory } from "react-router-dom";
import { useTheme } from "styled-components";
import packageInfo from "../../../package.json";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import LoginInput from "../../components/input/loginInput";
import LoginSelect from "../../components/select/loginSelect";
import LoginButton from "../../components/button/loginButton";
import Text from "../../components/text";
import Subtitle from "../../components/subtitle";

const { version } = packageInfo;

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [company, setCompany] = useState<CompanySelectOptions>();
  const [password, setPassword] = useState<string>('');

  const [emailError, setEmailError] = useState<boolean>(false);

  const [companyList, setCompanyList] = useState<CompanySelectOptions[]>([]);
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [isEmailChecked, setIsEmailChecked] = useState<boolean>(false);
  const [isReadyToSubmit, setIsReadyToSubmit] = useState<boolean>(false);
  const [isOptionsOpen, setIsOptionsOpen] = useState<boolean>(false);
  const [isPasswordChangeModalOpen, setisPasswordChangeModalOpen] = useState<boolean>(false);
  const [animateBackwards, setAnimateBackwards] = useState<boolean>(false);

  const { showErrorToast, showSuccessToast } = useContext(ToastContext);
  const { signIn, setIsPassExpired, isPassExpired, versaoServidor, setValidaAcessos } = useContext(AuthContext);
  const { setListCustumer } = useContext(CustumerContext);
  const history = useHistory();

  const theme = useTheme();

  useEffect(() => {
    setValidaAcessos(false)
  }, [])

  function handleClick() {
    if (!isEmailChecked) {
      checkEmail();
    } else if (!!company && !isReadyToSubmit) {
      setIsReadyToSubmit(true);
    } else if (isReadyToSubmit) {
      handleLogin();
    }
  }




  async function checkEmail() {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    try {
      setIsLoading(true);
      const isValid = email.match(regex);

      if (!isValid) {
        setEmailError(true);
        showErrorToast('E-mail inválido.')
        return;
      }

      const result = await APIAuth.validEmail(email);

      if (!result.err) {
        setCompanyList(formatOptions(result.groups));
        storage.setLicenseToken(result.token);
        setIsEmailChecked(true);
      } else {
        showErrorToast(result.message)
      }

    } catch {
      return;
    } finally {
      setIsLoading(false);
    }

  }




  function handleEmailChange(value: string) {
    setEmailError(false);
    setEmail(value.trim());
  }




  function handleCompanyChange(value: string | number) {
    const company = companyList.find(item => item.value === value);
    setCompany(company);
    try {
      storage.setClientUrl(company?.url + '/sar/rest/api');
    } catch (e) {
      throw new Error("Erro ao trocar empresa: " + e)
    }
  }




  function handlePasswordChange(value: string) {
    setPassword(value);
  }




  function resetEmail() {
    setIsEmailChecked(false);
    setIsReadyToSubmit(false);
    setAnimateBackwards(true);
    setCompany({ label: '', value: 0, url: '', logo: '' });
    setPassword('');
  }




  function formatOptions(groups: Group[]) {
    const formatted = groups.map(item => {
      return {
        label: item.razaoSocial,
        value: item.group_code,
        url: item.url,
        logo: item.logo
      }
    });

    return formatted;
  }




  function openOptions() {
    setIsOptionsOpen(true);
  }




  function closeOptions() {
    setIsOptionsOpen(false);
  }




  function handlePasswordDisplay() {
    setIsPasswordVisible(!isPasswordVisible);
  }




  async function handleLogin() {
    try {
      setIsLoading(true);
      const result = await APIAuth.validLogin({ user: email, pass: password, code: company ? company.value : '' });
      if (!result.err) {

        storage.setAccessToken(result.token);
        storage.setGroupLogged(company!.label);
        storage.setLogoGroupLogged(company!.logo);


        const custumers = await APIUser.getClientList();


        if (!custumers.error && custumers.clientes) {
          setListCustumer(custumers.clientes);
          signIn(email, result.versaoServidor, result.acessos ? result.acessos : false);
        } else {
          setIsPassExpired(custumers.status === 100);
          showErrorToast(custumers.message);
        }
        return;
      } else {
        showErrorToast(result.message);
      }
    } catch (e) {
      showErrorToast("Algo deu errado ao fazer o login")
      throw new Error("handleLogin: " + e)
    } finally {
      setIsLoading(false);
    }
  }




  function resolveButtonActivity() {
    if (!email || (isEmailChecked && !company) || (isReadyToSubmit && !password)) return true;
    return false
  }




  function formSubmit(e: React.FormEvent) {
    e.preventDefault();
    handleClick();
  }




  function showPasswordChangeModal() {
    setisPasswordChangeModalOpen(true);
  }




  function closePasswordChangeModal() {
    setisPasswordChangeModalOpen(false);
  }




  async function sendPasswordChangeEmail() {
    try {
      const result = await APIAuth.sendPasswordChangeEmail({ user: email, pass: '', code: company ? company.value : '' });

      if (!result.err) {
        showSuccessToast(`Código para troca de senha foi enviado para ${email}`);
        const params = {
          code: company?.value,
          email
        }
        const base64 = btoa(JSON.stringify(params));
        history.push(`trocadesenha/${base64}`)
      } else {
        showErrorToast(result.message);
      }
    } catch {
      return;
    }
  }




  async function handleChangeSuccess(token: string, acessos?: Number[] | boolean) {
    setIsPassExpired(false);

    storage.setAccessToken(token);

    const custumers = await APIUser.getClientList();

    if (!custumers.error && custumers.clientes) {
      setListCustumer(custumers.clientes);
      signIn(email, versaoServidor, acessos ? acessos : false);
    } else {
      if (custumers.status && custumers.status > 0) {
        showErrorToast("Não foi possível carregar clientes: " + custumers.message);
      }
    }
  }



  return (
    <>
      <div className="bg-[#f4f5f9] w-screen min-h-dvh flex flex-col relative">

        <section className="flex flex-col items-center mt-[clamp(10px,5vh,50px)] mb-[clamp(16px,4vh,40px)]">
          <img src={Logo} alt="Logo - Portal Cliente" className="w-[190px] max-[420px]:w-[160px]" />
          <Subtitle className="!font-normal !text-[#92A1B1] !text-[.85rem] !mt-[20px]">
            Sistema para Gestão de Clientes
          </Subtitle>
        </section>

        <div className="flex-1 flex justify-center items-start mb-[5px]">
          {isPassExpired && <PasswordChangeModal
            warning="Sua senha está expirada. Para usar a aplicação, cria uma nova senha."
            handleSuccess={handleChangeSuccess}
          />}

          {isPasswordChangeModalOpen &&
            <ConfirmationModal
              message="Será enviado em seu e-mail um código para que consiga efetuar a troca da senha"
              closeModal={closePasswordChangeModal}
              onActionClick={sendPasswordChangeEmail}
            />
          }
          {/* <div className="z-[-1] absolute top-0 left-0 w-[50%] h-screen rounded-tr-[50%] rounded-br-[50%] bg-[#eef0f5]" /> */}
          {/* <Title>Portal do Cliente</Title> */}

          <section className="w-[400px] max-[420px]:max-w-[300px] bg-white rounded-[10px] px-[20px] py-[25px] shadow-sm">

            <Text className="!text-[#92A1B1] text-center !text-[.85rem]">
              Entre com o e-mail e senha cadastrados
            </Text>

            <form className="flex flex-col gap-[20px] mt-[30px] overflow-hidden" onSubmit={formSubmit} >

              {!isEmailChecked &&
                <AnimationContainer direction={animateBackwards ? 'right' : ''}>
                  <LoginInput
                    label="Email"
                    placeholder="Digite seu email"
                    value={email}
                    onChange={(e) => handleEmailChange(e.target.value)}
                    errorMessage={emailError ? "Email inválido" : undefined}
                  />
                </AnimationContainer>
              }

              {isEmailChecked && (
                <AnimationContainer direction="left">
                  <SelectionLabel
                    label="Email"
                    value={email}
                    onClick={resetEmail}
                  />
                  {/* style={{ marginTop: 20, marginBottom: 0 }} */}

                  <div className="mt-5">
                    <LoginSelect
                      label="Prestador"
                      value={company?.label}
                      placeholder="Selecione seu prestador"
                      onOpenOptions={openOptions}
                    />
                  </div>
                </AnimationContainer>
              )}

              {isOptionsOpen && (
                <Options
                  selectOption={handleCompanyChange}
                  close={closeOptions}
                  itens={companyList}
                />
              )}


              {isReadyToSubmit &&
                <AnimationContainer direction={'left'}>
                  <div className="relative">
                    <LoginInput
                      label="Senha"
                      type="password"
                      placeholder="Digite sua senha"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      showPasswordToggle
                      isPasswordVisible={isPasswordVisible}
                      onTogglePassword={() => setIsPasswordVisible(v => !v)}
                    />

                  </div>
                  <Text
                    onClick={showPasswordChangeModal}
                    className="!text-right !cursor-pointer !select-none !mt-5"
                  >
                    Esqueci minha senha
                  </Text>
                </AnimationContainer >
              }

              <LoginButton type={'button'} onClick={handleClick} disabled={resolveButtonActivity()} loading={isLoading}>
                {isReadyToSubmit ? "ACESSAR" : "PRÓXIMO"}
              </LoginButton>

              <Text className="!text-center !mt-[10px] !font-light">
                Caso não consiga acessar, entre em contato com a empresa prestadora
              </Text>
            </form >
          </section>
        </div>

        <Text className="!text-[.75rem] !text-[#92A1B1] !mt-auto !pb-1 !text-center !self-center ">
          Desenvolvido por Grupo HK
        </Text>
        <Text className="!text-[.69rem] !text-[#92A1B1] !pb-2.5 !text-center !self-center !font-light">
          v{version}
        </Text>
      </div>
    </>
  )
}


export default Login;